import { apiFetch } from './api';

export async function setDemoPublished(deploymentId, published) {
    const res = await apiFetch(`/api/deployments/${deploymentId}/demo-publish`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ published })
    });

    if (!res.ok) {
        const text = await res.text();
        throw new Error(text || 'Failed to update demo page visibility.');
    }

    return res.json();
}
